/* eslint-disable import/order */
import React from 'react';
import { func, string } from 'prop-types';

// Components
import { Box, Button } from '@mui/material';
import { MDropdown } from 'common';

// Utils
import {
  AUTHORIZATION_FILTER_OPTIONS,
  EXTENDED_LOADING_FILTER,
  EXTENDED_LOADING_FILTER_OPTIONS,
} from 'utils/constants';
import { useUserRolePermissions } from 'hooks';

// Styles
import { filterButtonStyles, filterPopoverStyles } from './FilterPopover.styles';
import { useTheme } from '@mui/material/styles';

const FilterPopover = ({
  activeSelfAuthTab,
  authorizationSelection,
  extendedLoadingSelection,
  setFilters,
}) => {
  const theme = useTheme();
  const { isSubscriber } = useUserRolePermissions();
  const filterSelections = { authorizationSelection, extendedLoadingSelection };

  const showClear = Object.keys(filterSelections).some(
    key => filterSelections[key] !== EXTENDED_LOADING_FILTER.all
  );

  const clearFilter = () => {
    Object.keys(filterSelections).forEach(key => {
      if (filterSelections[key] !== EXTENDED_LOADING_FILTER.all) {
        setFilters({ name: key, value: EXTENDED_LOADING_FILTER.all });
      }
    });
  };

  return (
    <Box sx={filterPopoverStyles(theme)}>
      <Box sx={filterButtonStyles(theme)}>
        <MDropdown
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          id="authorization-select"
          items={AUTHORIZATION_FILTER_OPTIONS}
          label="Authorization"
          name="authorizationSelection"
          onChange={setFilters}
          value={authorizationSelection}
        />
      </Box>
      {activeSelfAuthTab === 'baseProducts' && isSubscriber && (
        <Box sx={filterButtonStyles(theme)}>
          <MDropdown
            anchorOrigin={{
              horizontal: 'center',
              vertical: 'top',
            }}
            id="extended-loading-select"
            items={EXTENDED_LOADING_FILTER_OPTIONS}
            label="Extended Loading"
            name="extendedLoadingSelection"
            onChange={setFilters}
            value={extendedLoadingSelection}
          />
        </Box>
      )}
      <Box sx={filterButtonStyles(theme)}>
        {showClear && (
          <Button aria-label="Clear" onClick={clearFilter} variant="text">
            Clear
          </Button>
        )}
      </Box>
    </Box>
  );
};

FilterPopover.propTypes = {
  activeSelfAuthTab: string,
  authorizationSelection: string.isRequired,
  extendedLoadingSelection: string.isRequired,
  setFilters: func.isRequired,
};

FilterPopover.defaultProps = {
  activeSelfAuthTab: undefined,
};

export default FilterPopover;
